import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import LogoText from "../assets/images/logowithtext.png";
import Divider from "../assets/images/wave.svg";
import GraduationImage from "../assets/images/graduation img.jpeg";
import HitsLogo from "../assets/images/HITSLogo.png";
import DividerFooter from "../assets/images/waveFooter.svg";
import "../style/about.css";

const Aboutpage = ({ setLocation }) => {
  const address = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setLocation(address);
  }, []);

  const handleNavigate = (goto) => {
    navigate(goto);
  };
  return (
    <main>
      <div className="custom-con1-about d-flex justify-content-center align-items-center">
        <div className="custom-con-content-section1-about d-flex justify-content-center align-items-center position-relative">
          <p className="custom-text-section1-about text-center">
            Empowering leaders to impact the world, for the cause of Christ
            through the local church.
          </p>
          <div className="custom-con-img-section1-about position-absolute start-50 bottom-0 translate-middle-x">
            <img
              className="adjust-photo-section1-about object-fit-scale"
              src={LogoText}
              alt="logo.png"
            />
          </div>
        </div>
      </div>
      <div className="custom-con-section2-about position-relative">
        <img
          className="position-relative top-0 start-0"
          src={Divider}
          alt="divider.svg"
        />
      </div>
      <div className="custom-con-section3-about d-flex justify-content-center align-items-center">
        <div className="custom-con-content-section3-about">
          <div className="row align-items-center m-0">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-5 col-xl-5 col-xxl-5 order-2 order-sm-2 order-md-2 order-lg-1 order-xl-1 order-xxl-1">
              <p className="custom-text1-section3-about">
                This could be your next step in life and ministry !
              </p>
              <p className="custom-text2-section3-about">
                Cutting Edge Academy is a learning and training program with a
                purpose to develop Christians and leaders to become increasingly
                rooted in God’s word and able to serve relevantly and
                strategically.
                <br />
                <br />
                The program will be held using a block teaching system, which 1
                course will be taught intensively for 5 days in the first week
                of each month.
                <br />
                <br />
                The Cutting Edge Academy program can be taken in full, that is 1
                year program with 10 courses alongside with Masterclass, IFGF
                Conference or taken per course.
              </p>
              <button
                className="custom-btn-section3-about"
                onClick={() => handleNavigate("/courses")}
              >
                Join Us
              </button>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-7 col-xl-7 col-xxl-7 order-1 order-sm-1 order-md-1 order-lg-2 order-xl-2 order-xxl-2">
              <div className="custom-con-img-section3-about">
                <img
                  className="adjust-photo-section3 object-fit-cover"
                  src={GraduationImage}
                  alt="graduationimg.png"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="custom-con-section4-about d-flex justify-content-center align-items-center position-relative">
        <div className="custom-con-content-section4-about">
          <div className="row align-items-center m-0 p-0">
            <div className="col-4 d-flex justify-content-center align-items-center m-0 p-0">
              <div className="custom-con-img-section4-about">
                <img
                  src={HitsLogo}
                  alt="HITSLogo.png"
                  className="adjust-photo-section4-about object-fit-scale"
                />
              </div>
            </div>
            <div className="col-8 d-flex justify-content-start align-items-center m-0 p-0">
              <p className="custom-text-section4-about text-center">
                Cutting Edge Academy credits are transferable <br />
                to Harvest International Theological Seminary (HITS){" "}
              </p>
            </div>
          </div>
        </div>
        <div className="custom-con-divider-footer-about position-absolute start-0 bottom-0">
          <img
            className="custom-divider-footer-about"
            src={DividerFooter}
            alt="dividerfooter.svg"
          />
        </div>
      </div>
    </main>
  );
};

export default Aboutpage;
